import {
  Loading,
  NotAuthorized,
  NotFound,
  PermissionDenied,
} from '@/components';
import type { FC, PropsWithChildren } from 'react';

import { useProjectPermission } from '../_hooks/permission';
import type { ResourceGuardProps } from '../_types/authentication';

export const ProjectResourceGuard: FC<
  PropsWithChildren<ResourceGuardProps>
> = ({ onlyEdit, showDenied, isLoading, children, ...rest }) => {
  const permission = useProjectPermission(onlyEdit);

  if (isLoading || permission.isLoading) {
    return <Loading />;
  }

  if (rest.isError) {
    const { errorProps } = rest;
    if (errorProps.errorStatus === 403) {
      return <NotAuthorized {...errorProps} />;
    }
    return <NotFound {...errorProps} />;
  }

  if (permission.data) {
    return <>{children}</>;
  }

  if (showDenied) {
    return <PermissionDenied />;
  }

  return null;
};
